import React, { useEffect } from "react";
import {
  Typography,
  Box,
  Tabs,
  Tab,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import { getSettingsThunk } from "../../features/settings/settings.thunk";

const TABS = [
  { label: "Sourcing", path: "/settings/sourcing" },
  { label: "Display", path: "/settings/display" },
  { label: "Layout", path: "/settings/layout" },
];

function Settings() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSettingsThunk());
  }, []);

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: "8px" }}>
        Settings
      </Typography>
      <Box display="flex" justifyContent={"start"}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "4px",
            padding: "4px",
            display: "inline-block",
            width: "auto",
            border: "1px solid #DCDDDD",
          }}
        >
          <Tabs
            value={location.pathname}
            onChange={(event: React.SyntheticEvent, newValue: string) => {
              navigate(newValue);
            }}
            sx={{
              minHeight: "auto",
              borderBottom: "none",
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTabs-flexContainer": {
                gap: "8px",
              },
            }}
          >
            {TABS.map((tab) => (
              <Tab
                label={tab.label}
                value={tab.path}
                sx={{
                  textTransform: "none",
                  minHeight: "auto",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#171A1F",
                  backgroundColor: "#FFFFFF",
                  border: "none",
                  transition: "all 0.2s",
                  "&.Mui-selected": {
                    backgroundColor: "#0F56CA",
                    color: "#fff",
                    border: "none",
                  },
                  "&:hover:not(.Mui-selected)": {
                    backgroundColor: "#FFFFFF",
                    border: "none",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#0F56CA",
                    border: "none",
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>
      </Box>
      {/* <Box display="flex" borderBottom={1} borderColor="divider" mb={2}>
        {tabs.map((tab) => (
          <Button
            key={tab.path}
            component={Link}
            to={tab.path}
            sx={{
              borderBottom:
                location.pathname === tab.path ? "2px solid #1976d2" : "none",
              borderRadius: 0,
              textTransform: "none",
              mr: 2,
            }}
          >
            {tab.label}
          </Button>
        ))}
      </Box> */}
      <Divider
        sx={{
          height: "1px",
          backgroundColor: "#DEE1E6",
          mt: "8px",
        }}
      />
      <Box margin="8px 0">
        <Outlet />
      </Box>
    </Box>
  );
}

export default Settings;
